import "../../../styles/dashboard-tokens.css";

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    // `data-design="refined-teal"` re-establishes the dashboard token scope on
    // the auth pages so shared chrome (`.d-btn`, `.d-checkbox`, `.d-card`,
    // `.d-ctrl-pill`, …) renders correctly. Without this scope the checkbox
    // becomes a bare native input and the primary button loses its pill
    // styling — see the design-system migration note in dashboard-tokens.css.
    <div
      data-design="refined-teal"
      className="auth-layout min-h-screen w-full flex flex-col items-center justify-center px-4 py-10"
    >
      {children}
    </div>
  );
}
